<template>
  <b-modal
    :id="'updateFolder-' + folder_id"
    hide-footer
    @shown="getFolderById"
    @hidden="$emit('close')"
    no-close-on-backdrop
    modal-class="modern-modal"
    size="lg"
  >
    <template v-slot:modal-title>
      <div class="modal-title-modern">
        <i class="fas fa-folder-open mr-2"></i>
        Editar Pasta
      </div>
    </template>

    <div class="modal-content-modern">
      <div class="form-container">
        <!-- Folder Name Section -->
        <div class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-tag mr-2"></i>
              Informações da Pasta
            </h4>
          </div>

          <div class="form-group">
            <LabelRequiredField label="Nome da Pasta" />
            <input
              type="text"
              v-model="folder.name"
              class="modern-form-input"
              placeholder="Digite o nome da pasta"
            />
          </div>
        </div>

        <!-- Privacy Section -->
        <div class="form-section">
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-shield-alt mr-2"></i>
              Configurações de Privacidade
            </h4>
          </div>

          <div class="privacy-controls">
            <div class="privacy-options">
              <button
                type="button"
                :class="[
                  'privacy-btn',
                  'public-btn',
                  { active: folder.public_folder == 1 },
                ]"
                @click="folder.public_folder = 1"
              >
                <i class="fas fa-globe mr-2"></i>
                <div class="btn-content">
                  <span class="btn-title">PÚBLICA</span>
                  <span class="btn-subtitle">Todos podem visualizar</span>
                </div>
              </button>

              <button
                type="button"
                :class="[
                  'privacy-btn',
                  'private-btn',
                  { active: folder.public_folder == 0 },
                ]"
                @click="folder.public_folder = 0"
              >
                <i class="fas fa-lock mr-2"></i>
                <div class="btn-content">
                  <span class="btn-title">PRIVADA</span>
                  <span class="btn-subtitle">Acesso restrito</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <div v-if="folder.public_folder == 0" class="form-section">
          <div class="section-header">
            <h4 class="section-title">Vincular por:</h4>
          </div>

          <div class="privacy-controls">
            <div class="privacy-options">
              <button
                type="button"
                :class="[
                  'privacy-btn',
                  'public-btn',
                  { active: folder.link_folder == 'USER' },
                ]"
                @click="folder.link_folder = 'USER'"
              >
                <i class="fas fa-user mr-2"></i>
                <div class="btn-content">
                  <span class="btn-title">USUÁRIO</span>
                </div>
              </button>

              <button
                type="button"
                :class="[
                  'privacy-btn',
                  'private-btn',
                  { active: folder.link_folder == 'PROFILE' },
                ]"
                @click="folder.link_folder = 'PROFILE'"
              >
                <i class="fas fa-users mr-2"></i>
                <div class="btn-content">
                  <span class="btn-title">PERFIL</span>
                </div>
              </button>
            </div>
          </div>
        </div>

        <!-- Users Selection Section -->
        <div
          v-if="folder.public_folder == 0 && folder.link_folder == 'USER'"
          class="form-section"
        >
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-users mr-2"></i>
              Usuários com Acesso
            </h4>
            <p class="section-description">
              Selecione os usuários que poderão visualizar esta pasta
            </p>
          </div>

          <div class="form-group">
            <LabelRequiredField label="Usuários para Visualização" />
            <div class="select-wrapper">
              <v-select
                v-model="users_ids"
                :items="users"
                item-text="name"
                item-value="id"
                multiple
                clearable
                outlined
                dense
                ref="userSelect"
                @change="closeSelectUser"
                class="modern-select"
                placeholder="Selecione os usuários"
                hide-details
              />
            </div>
          </div>
        </div>

        <div
          v-if="folder.public_folder == 0 && folder.link_folder == 'PROFILE'"
          class="form-section"
        >
          <div class="section-header">
            <h4 class="section-title">
              <i class="fas fa-users mr-2"></i>
              Perfis com Acesso
            </h4>
            <p class="section-description">
              Selecione os perfis que poderão visualizar esta pasta
            </p>
          </div>

          <div class="form-group">
            <LabelRequiredField label="Perfis para Visualização" />

            <div class="select-wrapper">
              <v-select
                v-model="profiles_ids"
                :items="profiles"
                item-text="name"
                item-value="id"
                multiple
                clearable
                outlined
                dense
                ref="profileSelect"
                @change="closeSelectProfile"
                class="modern-select"
                placeholder="Selecione os perfis"
                hide-details
              />
            </div>
          </div>
        </div>

        <!-- Error Messages -->
        <div v-if="errors.length > 0" class="errors-section">
          <ErrorsMessages :errors="errors" />
        </div>

        <!-- Actions -->
        <div class="form-actions">
          <v-btn
            class="btn-cancel-modern"
            @click="$bvModal.hide('updateFolder-' + folder_id)"
          >
            <i class="fas fa-times mr-2"></i>
            Cancelar
          </v-btn>

          <v-btn :disabled="loading" class="btn-save-modern" @click="update">
            <i class="fas fa-save mr-2"></i>
            {{ loading ? "Salvando..." : "Salvar Pasta" }}
          </v-btn>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../lib/ToastNotification";

export default {
  name: "UpdateFolder",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      errors: [],

      folder: [],

      users_ids: [],

      profiles_ids: [],

      users: [],

      profiles: [],

      loading: false,
    };
  },

  mounted() {
    this.getUsers();

    this.getProfiles();
  },

  props: {
    folder_id: {
      type: Number,
      default: null,
    },
  },

  methods: {
    async getFolderById() {
      try {
        this.loading = true;

        let params = { id: this.folder_id };

        const response = await api.get("/folder", { params });

        const { folder, error, message } = response.data;

        if (!error) {
          this.folder = folder;

          if (folder.users) {
            this.users_ids = folder.users.map((user) => user.user_id);
          }

          if (folder.profiles) {
            this.profiles_ids = folder.profiles.map(
              (profile) => profile.profile_id
            );
          }
        } else {
          this.$bvModal.hide("updateFolder-" + this.folder_id);
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    async getUsers() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/users");

        const { error, users } = response.data;

        if (!error) {
          this.users = users;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error(error);
      }
    },

    async getProfiles() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/profiles");

        const { error, profiles } = response.data;

        if (!error) {
          this.profiles = profiles;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        const id = this.folder.id;
        const name = this.folder.name;
        const public_folder = this.folder.public_folder;
        const users_ids = this.users_ids;
        const link_folder = this.folder.link_folder;
        const profiles_ids = this.profiles_ids;

        let params = {
          id,
          name,
          public_folder,
          users_ids,
          link_folder,
          profiles_ids,
        };

        const response = await api.put("/folder", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("updateFolder-" + this.folder_id);
          toast(message, "success");
          this.errors = [];
          this.$emit("update");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    closeSelectUser() {
      this.$refs.userSelect.blur();
    },

    closeSelectProfile() {
      this.$refs.profileSelect.blur();
    },
  },
};
</script>

<style scoped>
/* Modal Styling */
.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-title-modern i {
  color: #0f65b0;
}

.modal-content-modern {
  padding: 8px 0;
}

/* Form Container */
.form-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Form Sections */
.form-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
}

.section-header {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e5e7eb;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #0f65b0;
}

.section-description {
  color: #64748b;
  font-size: 14px;
  margin: 8px 0 0 0;
}

/* Form Groups */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modern-form-input {
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  background: white !important;
}

.modern-form-input:focus {
  border-color: #0f65b0 !important;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1) !important;
  outline: none !important;
}

.modern-form-input::placeholder {
  color: #9ca3af !important;
}

/* Privacy Controls */
.privacy-controls {
  background: white;
  border-radius: 8px;
  padding: 16px;
}

.privacy-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.privacy-btn {
  display: flex;
  align-items: center;
  padding: 20px;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
}

.privacy-btn:hover {
  border-color: #cbd5e1;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.privacy-btn.active {
  border-color: #0f65b0;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.2);
}

.privacy-btn i {
  font-size: 20px;
  color: #6b7280;
  margin-right: 12px;
}

.privacy-btn.active i {
  color: #0f65b0;
}

.btn-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.btn-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.privacy-btn.active .btn-title {
  color: #0f65b0;
}

.btn-subtitle {
  font-size: 12px;
  color: #6b7280;
}

.privacy-btn.active .btn-subtitle {
  color: #0369a1;
}

/* Select Wrapper */
.select-wrapper {
  background: white;
  border-radius: 8px;
  padding: 4px;
}

/* Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.btn-cancel-modern {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease !important;
}

.btn-cancel-modern:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px) !important;
}

.btn-save-modern {
  background: linear-gradient(135deg, #1e884d 0%, #16a34a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(30, 136, 77, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-save-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(30, 136, 77, 0.4) !important;
}

.btn-save-modern:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

/* Error Section */
.errors-section {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 1px solid #fca5a5;
  border-radius: 12px;
  padding: 20px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-content-modern {
    padding: 0;
  }

  .form-container {
    gap: 20px;
  }

  .form-section {
    padding: 16px;
  }

  .privacy-options {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .privacy-btn {
    padding: 16px;
  }

  .form-actions {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .btn-cancel-modern,
  .btn-save-modern {
    width: 100% !important;
    justify-content: center !important;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 14px;
  }

  .privacy-btn {
    padding: 12px;
  }

  .privacy-btn i {
    font-size: 18px;
  }

  .btn-title {
    font-size: 13px;
  }

  .btn-subtitle {
    font-size: 11px;
  }
}

/* Override Vuetify styles */
.modern-select >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-select__slot {
  padding: 8px 12px !important;
}

.modern-select >>> .v-select__selections {
  font-weight: 500 !important;
}

.modern-select >>> .v-chip {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%) !important;
  color: #0369a1 !important;
  border: 1px solid #7dd3fc !important;
}

/* Modal Global Overrides */
.modern-modal >>> .modal-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-bottom: 1px solid #e5e7eb !important;
  border-radius: 0 !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}

.modern-modal >>> .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

@media (max-width: 768px) {
  .modern-modal >>> .modal-body {
    padding: 16px !important;
  }
}
</style>